import React from 'react';
import { Button, Chip, Container, Stack, Typography } from '@mui/material';
import { theme } from '../../../theme';
import { formatCurrency } from '../../../utils/formatNumbers';

function ItemReplacementActions({ selectedCount, cardCount, totalSavings, status, isUpdating, onAcceptSelected, onDeclineAll, onUndo, navigationAction }) {
    return (
        <Stack sx={{ position: 'sticky', bottom: 0, flexShrink: 0, width: '100%', backgroundColor: theme.palette.background.white, boxShadow: theme.shadows[2], zIndex: 2 }}>
            <Container maxWidth={false} disableGutters sx={{ width: '100%', px: { xs: 1.5, sm: 2 }, py: 1.25 }}>
                <Stack direction='row' alignItems='center' justifyContent='space-between' spacing={1} mb={1.25}>
                    <Typography variant='normal' sx={{ color: theme.palette.subtext.secondary, fontSize: '13px' }}>Selected: {selectedCount} of {cardCount}</Typography>
                    <Chip label={`Projected Max Savings: ${formatCurrency(totalSavings, 0)}/yr`} sx={{ backgroundColor: theme.palette.itemSwapChip.background.positive, color: theme.palette.itemSwapChip.text.positive, fontFamily: 'Roboto', fontWeight: theme.typography.heavy.fontWeight, fontSize: '12px' }} />
                </Stack>
                {status === 'open' &&
                    <Stack direction='row' spacing={1.25}>
                        <Button variant='grayContained' disabled={isUpdating} onClick={onDeclineAll} fullWidth>
                            Decline All
                        </Button>
                        <Button variant='blueContained' disabled={selectedCount === 0 || isUpdating} onClick={onAcceptSelected} fullWidth>
                            {selectedCount === cardCount ? 'Accept All' : 'Accept Selected'}
                        </Button>
                    </Stack>
                }
                {status !== 'open' &&
                    <Stack direction='row' spacing={1.25}>
                        <Button variant='contained' disabled={isUpdating} onClick={onUndo} fullWidth>
                            {status === 'rejected' ? 'Undo Decline' : 'Undo Replacement'}
                        </Button>
                        {navigationAction && (
                            <Button variant='blueContained' disabled={isUpdating} onClick={navigationAction.onClick} fullWidth>
                                {navigationAction.label}
                            </Button>
                        )}
                    </Stack>
                }
            </Container>
        </Stack>
    );
}

export default ItemReplacementActions;
